import { BaseEntityInfoUtils, EntityInfo } from '@record-it-npm/synchro-common';
import { AppCommonSynchronizationEnvironmentTypes } from '../../../AppCommonSynchronizationEnvironment';
import { EntityName } from '../../../EntityName';
import { CreateEntityInfoOptions } from '../../base/CreateEntityInfoOptions';
import { ConstructionSiteUsageStatisticDto } from './ConstructionSiteUsageStatisticDto';
export function createConstructionSiteUsageStatisticEntityInfo<TEntity extends ConstructionSiteUsageStatisticDto>(options: CreateEntityInfoOptions<ConstructionSiteUsageStatisticDto, TEntity>): EntityInfo<AppCommonSynchronizationEnvironmentTypes, EntityName.ConstructionSiteUsageStatistic, TEntity> {
  return {
    entityName: EntityName.ConstructionSiteUsageStatistic,
    synchronizeRelativeTo: [],
    trackGlobalRevision: true,
    fieldInfos: BaseEntityInfoUtils.createFieldInfos<AppCommonSynchronizationEnvironmentTypes, ConstructionSiteUsageStatisticDto, TEntity>({
      ...BaseEntityInfoUtils.createBaseFieldInfos<AppCommonSynchronizationEnvironmentTypes>(),
      userId: {
        name: 'userId',
        ref: EntityName.User,
        cascadeDeleteLocally: true
      },
      constructionSiteId: {
        name: 'constructionSiteId',
        ref: EntityName.ConstructionSite,
        cascadeDeleteLocally: true
      },
      usageCount: {
        name: 'usageCount',
        defaultValue: 0
      },
      lastUsedDate: {
        name: 'lastUsedDate',
        defaultValue: null
      }
    }, options.additionalFieldInfos)
  };
}